<template>
  <v-form
    @submit="onSubmit"
    :action="this.server + this.$route.fullPath"
    ref="form"
    id="form-pregnant"
    v-model="valid"
    lazy-validation
  >
    <div class="text-center mb-4">
      <div
        class="
          d-inline-flex
          align-center
          white--text
          text-h6 text-sm-h5 text-md-h3
          item-title
          no-wrap
        "
      >
        {{ title }}
      </div>
    </div>

    <v-row class="my-0">
      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          class="field-text"
          hide-details
          height="48px"
          background-color="#ffffff"
          rounded
          name="name"
          :rules="nameRules"
          label="Nome"
          required
        ></v-text-field>

        <v-text-field
          class="field-text"
          hide-details
          height="48px"
          background-color="#ffffff"
          rounded
          name="tel"
          :rules="telRules"
          label="Telefone"
          required
          v-mask="['(##) ####-####', '(##) #####-####']"
        ></v-text-field>

        <v-text-field
          class="field-text"
          hide-details
          height="48px"
          background-color="#ffffff"
          rounded
          name="city"
          :rules="cityRules"
          label="Cidade"
          required
        ></v-text-field>

        <v-text-field
          class="field-text"
          hide-details
          height="48px"
          background-color="#ffffff"
          rounded
          name="career"
          :rules="careerRules"
          label="Profissão"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          class="field-text"
          hide-details
          height="48px"
          background-color="#ffffff"
          rounded
          name="pregnant_week"
          :rules="pregnantWeekRules"
          label="Semana de gestação"
          required
        ></v-text-field>

        <v-select
          class="field-text"
          v-model="firstPregnantTime"
          hide-details
          height="48px"
          background-color="#ffffff"
          rounded
          :items="[
            {
              text: 'Sim',
              value: 1,
            },
            {
              text: 'Não',
              value: 0,
            },
          ]"
          name="first_pregnant_time"
          :rules="firstPregnantTimeRules"
          label="É a sua primeira gestação?"
          required
        ></v-select>

        <v-text-field
          v-if="firstPregnantTime === 0"
          class="field-text"
          hide-details
          height="48px"
          background-color="#ffffff"
          rounded
          name="sons"
          :rules="sonsRules"
          label="Quantos filhos?"
          required
        ></v-text-field>

        <v-text-field
          class="field-text"
          hide-details
          height="48px"
          background-color="#ffffff"
          rounded
          name="prenatal"
          :rules="prenatalRules"
          label="Local do pré-natal"
          required
        ></v-text-field>

        <v-text-field
          class="field-text"
          hide-details
          height="48px"
          background-color="#ffffff"
          rounded
          name="responsible"
          :rules="responsibleRules"
          label="Profissional responsável"
          required
        ></v-text-field>
      </v-col>
    </v-row>

    <v-checkbox
      name="policy_privacy"
      v-model="policyPrivacy"
      :rules="[(v) => !!v || 'Você precisa aceitar para continuar.']"
      required
      value="1"
      hide-details
      class="mt-2 policy-privacy"
    >
      <template v-slot:label>
        <div>
          Eu li e concordo com a
          <a class="primary--text" @click="showPrivacy">
            Política de Privacidade.
          </a>
        </div>
      </template>
    </v-checkbox>

    <div class="text-center mt-3">
      <v-btn
        color="#FE8A00"
        :loading="loadingForm"
        class="text-h6 white--text text-none px-8 mt-2"
        type="submit"
        height="48px"
        depressed
        rounded
      >
        REGISTRAR
      </v-btn>
    </div>

    <v-snackbar :color="color" centered v-model="snackbar" :multi-line="true">
      <span>
        {{ response }}
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false" icon>
          <v-icon> fa fa-times </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import { telTest } from "../../utils/telTest";

export default {
  props: {
    title: {
      type: String,
    },
  },
  data: () => ({
    firstPregnantTime: null,
    response: "",
    color: "success",
    loadingForm: false,
    snackbar: false,
    valid: true,
    nameRules: [(v) => !!v || "Informe seu nome."],
    telRules: [
      (v) => !!v || "Informe seu telefone.",
      (v) => telTest(v) || "Informe um telefone válido",
    ],
    cityRules: [(v) => !!v || "Informe sua cidade."],
    careerRules: [(v) => !!v || "Informe sua profissão."],
    pregnantWeekRules: [(v) => !!v || "Informe a semana de gestação."],
    firstPregnantTimeRules: [
      (v) => v != 0 || v != 1 || "Informe se é sua primeira gestação.",
    ],
    sonsRules: [(v) => !!v || "Informe quantos filhos já tem."],
    prenatalRules: [(v) => !!v || "Informe o local do pré-natal."],
    responsibleRules: [(v) => !!v || "Informe o profissional responsável."],
    policyPrivacy: false,
  }),
  methods: {
    showPrivacy: () => window.showPrivacyPolicy(),
    onSubmit(event) {
      const form = document.getElementById("form-pregnant");

      if (this.$refs.form.validate()) {
        this.loadingForm = true;

        const formData = new FormData(form);
        const action = `${this.server}/rest/email/pregnant`;

        fetch(action, {
          method: "POST",
          body: formData,
        })
          .then((r) => {
            if (r.ok) {
              this.$refs.form.reset();

              this.response =
                "Cadastro realizado com sucesso. Em breve entraremos em contato.";
              this.color = "success";
              this.snackbar = true;
              this.loadingForm = false;
            } else {
              this.response =
                "OPS! tivemos um problema no envio das informações, tente novamente mais tarde.";
              this.color = "red accent-2";
              this.snackbar = true;
              this.loadingForm = false;
            }
          })
          .catch(() => {
            this.response =
              "OPS! tivemos um problema no envio das informações, tente novamente mais tarde.";
            this.color = "red accent-2";
            this.snackbar = true;
            this.loadingForm = false;
          });
      }

      event.preventDefault();
    },
  },
  directives: {
    mask,
  },
};
</script>

<style lang="scss" scoped>
.no-wrap {
  white-space: nowrap;
}
.item-title {
  background-color: #fe8a00;
  height: 44px;
  padding-left: 48px;
  padding-right: 48px;
  position: relative;

  &:before,
  &:after {
    border-color: transparent #fe8a00 transparent transparent;
    border-style: solid;
    border-width: 0 10px 44px 0;
    content: "";
    height: 0px;
    position: absolute;
    right: 100%;
    top: 0;
    width: 0px;
  }

  &:after {
    bottom: 0;
    left: 100%;
    right: auto;
    top: auto;
    transform: rotate(180deg);
  }
}

.field-text::v-deep {
  .v-label {
    font-size: 14px !important;
  }
  .v-input__slot {
    box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
}
</style>
